import { Component, Input } from '@angular/core';
import { AngularNodeViewComponent } from 'ngx-tiptap';

@Component({
  template: ''
})
export abstract class ItemSelectionComponent extends AngularNodeViewComponent{
  @Input() items = [];
  public selectedIndex = 0;

// Method to set items programmatically
  setItems(items) {
    this.items = items;
  }    

  upHandler() {
    if (this.selectedIndex - 1 < 0) {
      this.selectedIndex = this.items.length - 1; // Wrap to the end
    } else {
      this.selectedIndex -= 1; // Move to the previous item
    }
  }

  downHandler() {
    if (this.selectedIndex + 1 >= this.items.length) {
      this.selectedIndex = 0; // Wrap to the start
    } else {
      this.selectedIndex += 1; // Move to the next item
    }
  }

  enterHandler() {
    this.selectItem(this.selectedIndex);
  }

  // Abstract method to be implemented in subclasses
  abstract selectItem(index: number): void;
}
